import { useState } from 'react';
import { toast } from 'react-toastify';

import { ProfileTabKey } from '@/contents/user-profile/content';
import { useRouter } from '@/provider/RouterProvider';
import { useAuth } from '@/provider/UserProvider';
import { deleteCollection } from '@/services/collection';

const useDeleteCollection = () => {
  const [loading, setLoading] = useState(false);
  const { auth } = useAuth();
  const router = useRouter();

  const handleDeleteCollection = async (collectionId: number) => {
    try {
      setLoading(true);
      await deleteCollection(collectionId);
      setLoading(false);
      toast.success('Delete collection successfully!');
      router.push(`/profile/${auth.user.publicAddress}?tab=${ProfileTabKey.collection}`);
    } catch (error: any) {
      toast.error(error?.message);
    }
  };

  return { handleDeleteCollection, loading };
};

export default useDeleteCollection;
